import React from 'react';
export const AddressBookPersonButton = function EmptyComponent() { return null; };
